import React from 'react';
import { CandidatesState, MatchScore } from './types';
import { TCandidate } from './types';
import { TableCell } from '@mui/material';
import { classes } from '../../NewUI/Components/GenericTable/styles';
import CandidateIcon from '../Candidate/CandidateIcon';
import { AccessTimeFilled, Close, Check, DoneAll } from '@mui/icons-material';
import { theme } from '../../ThemeContext/ThemeObject';

interface CandidatesTableRowsProps {
  column: CandidatesState['candidatesTableState']['columns'][number];
  item: TCandidate;
  tableHovered: boolean;
  onShowDetails?: (candidate: TCandidate) => void;
  onExpand?: () => void;
}

const CandidatesTableRows = ({
  column,
  item,
  tableHovered,
  onShowDetails,
  onExpand
}: CandidatesTableRowsProps) => {
  if (!column.enabled) return null;
  const Link = ({ attribute }: { attribute: 'candidate_id' | 'lastname' | 'firstname' }) => (
    <a href={`/admin/candidates/${item.candidate_id}`} id={`candidate-${attribute}-link`}>
      {item[attribute] || '-'}
    </a>
  );

  const matchingConditionIndicator = (conditionId: number) => {
    const matchingCondition = item.matching_conditions.find((cond) => cond.id === conditionId);
    if (
      !matchingCondition ||
      matchingCondition.matched_score === null ||
      matchingCondition.matched_score === undefined
    ) {
      return <AccessTimeFilled color="disabled" />;
    }

    switch (matchingCondition.matched_score) {
      case MatchScore.EXCELLENT:
        return <DoneAll sx={{ color: theme.palette.success.main }} />;
      case MatchScore.GOOD:
        return <Check sx={{ color: theme.palette.secondary.yellow }} />;
      default:
        return <Close sx={{ color: theme.palette.error.main }} />;
    }
  };

  if (column.id.startsWith('condition_')) {
    const conditionId = parseInt(column.id.split('_')[1]);
    return (
      <TableCell
        key={item.id + column.id}
        onClick={(e) => {
          e.stopPropagation();
          if (onExpand) {
            onExpand();
          }
        }}
        sx={{
          cursor: onShowDetails || onExpand ? 'pointer' : 'default'
        }}
      >
        {matchingConditionIndicator(conditionId)}
      </TableCell>
    );
  }

  switch (column.id) {
    case 'id':
      return (
        <TableCell
          key={item.id + column.id}
          sx={{
            ...classes.sticky,
            ...classes.itemTitleTableCell,
            left: '58px',
            ...(tableHovered && classes.scrollShadowVisible),
            width: '100px',
            minWidth: '120px'
          }}
        >
          <CandidateIcon
            existingCandidate={item.existing_candidate}
            sx={{
              fontSize: '1rem',
              margin: '-3px 7px 0 0'
            }}
          />
          <Link attribute="candidate_id" />
        </TableCell>
      );
    case 'lastname':
      return (
        <TableCell key={item.id + column.id}>
          <Link attribute="lastname" />
        </TableCell>
      );
    case 'firstname':
      return (
        <TableCell key={item.id + column.id}>
          <Link attribute="firstname" />
        </TableCell>
      );
    case 'email':
      return <TableCell key={item.id + column.id}>{item.email || '-'}</TableCell>;
    case 'matching_percent':
      return (
        <TableCell
          key={item.id + column.id}
          sx={{
            cursor: onShowDetails ? 'pointer' : 'default'
          }}
          onClick={() => onShowDetails && onShowDetails(item)}
        >
          <span style={{ color: item.matching_percent_color }}>
            {item.matching_percent !== null && item.matching_percent !== undefined
              ? `${item.matching_percent}%`
              : 'Calculating...'}
          </span>
        </TableCell>
      );
    default:
      return <TableCell></TableCell>;
  }
};

export default CandidatesTableRows;
